import { useState } from "react";
import { Button, Fade, Slide, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import * as S from "./styles";
import { signInAnonymously, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../services/firebase";
import { firebaseErrorsHandler, justNumbersParser } from "../../utils";
import { CPF_VALIDATION } from "../../utils/yup-validations";

const loginSchema = yup.object({
  cpf: CPF_VALIDATION,
});

interface ILoginForm {
  cpf: string;
}

const Login = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ILoginForm>({ resolver: yupResolver(loginSchema) });
  const [logging, setLogging] = useState(false);
  const [loggingAnonymous, setLoggingAnonymous] = useState(false);

  const onSubmit = (data: ILoginForm) => {
    setLogging(true);
    const email = `${justNumbersParser(data.cpf)}@arena.com`;
    signInWithEmailAndPassword(auth, email, "123456")
      .catch((error) => alert(firebaseErrorsHandler(error?.code)))
      .finally(() => setLogging(false));
  };
  const handleLoginAnonymously = () => {
    setLoggingAnonymous(true);
    signInAnonymously(auth)
      .catch((error) => alert(firebaseErrorsHandler(error?.code)))
      .finally(() => setLoggingAnonymous(false));
  };

  const someLoading = logging || loggingAnonymous;

  return (
    <Fade in timeout={1000}>
      <S.LoginContainer>
        <img src="/logo192.png" alt="Logo da Rede Arena" />
        <Slide direction="up" in timeout={500}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              label="Coloque seu CPF"
              inputProps={{ inputMode: "numeric" }}
              {...register("cpf")}
              error={!!errors?.cpf}
              helperText={errors?.cpf?.message as string}
              disabled={someLoading}
            />
            <Button
              variant="contained"
              size="large"
              type="submit"
              disabled={someLoading}
              sx={{ m: "1rem 0" }}
            >
              {logging ? "Entrando..." : "Entrar no aplicativo"}
            </Button>
            <Button
              variant="text"
              size="large"
              disabled={someLoading}
              onClick={handleLoginAnonymously}
            >
              {loggingAnonymous ? "Entrando..." : "Entrar como visitante"}
            </Button>
            <Typography
              variant="caption"
              sx={{ m: "auto auto 0 auto", opacity: 0.5 }}
              align="center"
            >
              Todos os direitos reservados
              <br />© Rede Arena - 2023
            </Typography>
          </form>
        </Slide>
      </S.LoginContainer>
    </Fade>
  );
};

export default Login;
